<a [href]="material.filepath" target="_blank" rel="noopener nofollow" class="btn btn-outline-secondary">
  {{ "demo.educationalMaterial.preview.openInNewTab" | translate }}
</a>

<div class="ratio ratio-1x1">
  <iframe [src]="material.filepath | safe"></iframe>
</div>
